module.exports = __webpack_public_path__ + "img/kyc_check.b6bdee61.svg";